import { ThemeUIStyleObject } from 'theme-ui'

export const text: Record<string, ThemeUIStyleObject> = {
  default: {
    color: 'text',
    fontSize: 2,
    fontFamily: 'body',
    fontWeight: 'body',
    mb: 3,
  },
  caps: {
    letterSpacing: '.2rem',
  },
  hero: {
    variant: 'text.default',
    color: 'inverted',
    mb: 3,
    fontSize: [1, 2],
  },
  heading: {
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    mb: 2,
  },
  heroHeading: {
    variant: 'heading',
    color: 'inverted',
    fontSize: [3, 5],
    fontWeight: 700,
    marginBottom: 3,
  },
  smallprint: {
    variant: 'text.default',
    fontSize: 1,
  },
}
